import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output, QueryList, ViewChildren
} from "@angular/core";
import {DxSideNavigationMenuOptions} from "../../../../domain/ui-options/dx-navigator/dx-side-navigation-menu-options";
import {DxNavigationTreeNodeDataProvider} from "../../../../domain/navigator/dx-navigation-tree-node-data-provider";
import {DxNavigationTreeNode} from "../../../../domain/navigator/dx-navigation-tree-node";
import {DxNavigationTree} from "../../../../domain/navigator/dx-navigation-tree";
import {DxAppEvent} from "../../../../../dx-core/domain/events/dx-app-event";
import {DxSideDropdownListComponent} from "./side-dropdown-list/dx-side-dropdown-list.component";



@Component({
  selector: 'dx-side-navigation-menu',
  templateUrl: './dx-side-navigation-menu.component.html',
  styleUrls: ['./dx-side-navigation-menu.component.css']
})
export class DxSideNavigationMenuComponent implements OnInit, OnDestroy, AfterViewInit {
  /** Опции (настройки) бокового навигационного меню */
  @Input()
  public options: DxSideNavigationMenuOptions;
  /** Массив (плоская иерархия) объектов данных, являющихся исходными для построения навигационного дерева */
  @Input()
  public menuData: DxNavigationTreeNodeDataProvider[];

  /** Флаг, переключающий минифицированное \ развернутое состояние. */
  private _isMinified: boolean = false;

  // Структуры данных для работы меню
  /** Навигационное дерево */
  private _menuTree: DxNavigationTree;
  /** Узлы первого уровня бокового навигационного дерева. */
  private _items: DxNavigationTreeNode[];
  /** Текущий активный элемент */
  private _activeItem: DxNavigationTreeNode;
  /** Текущий раскрытый элемент */
  private _expandedItem: DxNavigationTreeNode;

  /** Доступ к инстансам выпадающих списков. */
  @ViewChildren(DxSideDropdownListComponent)
  public dropDownListQL: QueryList<DxSideDropdownListComponent>;
  public dropDownLists: DxSideDropdownListComponent[];

  /**
   * Событие выбрасывается при клике по эелемту меню или подменю.
   */
  @Output()
  public openMenuItem: EventEmitter<DxAppEvent> = new EventEmitter();


  /** @constructor */
  constructor(private _changeDetector: ChangeDetectorRef) {
    this._items = [];
    this.dropDownLists = [];
  }

  ngOnInit(): void {
    if(this.options) {

    }
    this._init();
  }

  ngAfterViewInit(): void {
    this.dropDownLists.length = 0;
    this.dropDownListQL.forEach(item => this.dropDownLists.push(item));
  }

  ngOnDestroy(): void { }


  get isMinified(): boolean {
    return this._isMinified;
  }

  get menuTree(): DxNavigationTree {
    return this._menuTree;
  }

  get items(): DxNavigationTreeNode[] {
    return this._items;
  }


  public onMenuTogglerClick(): void {
    this._isMinified = !this._isMinified;
  }

  public onMenuItemClick(item: DxNavigationTreeNode): void {
    if(!(this._activeItem && this._activeItem.id === item.id)) {
      this._activeItem = item;
      if(!item.hasChildren) {
        this.openMenuItem.emit(new DxAppEvent('dx-side-navigation-menu', item));
      }
    }
  }

  public onToggleDropDownPanel(item: DxNavigationTreeNode): void {
    if(this._expandedItem && this._expandedItem.id === item.id) {
      this._expandedItem = null;
    } else {
      this._expandedItem = item;
    }
  }

  public onSumMenuItemClick(event: DxAppEvent): void {
    this.openMenuItem.emit(event)
  }


  public restoreSelection(segments?: string[]): void {
    if(segments) {
      const nodes = this._menuTree.findNodesByRoutes(segments);
      if(nodes && nodes.length > 0) {
        const nodeWithMaxDepth = nodes.reduce((prev, current) => (prev.level > current.level) ? prev : current);
        if(nodeWithMaxDepth.level === 1) {
          this._activeItem = nodeWithMaxDepth;
          this._expandedItem = null;
          this._items = [...this._items];
          this._changeDetector.detectChanges();
        } else if(nodeWithMaxDepth.level > 1) {
          let parent = nodeWithMaxDepth;
          while (parent && parent.level !== 1) parent = parent.parent;

          this._activeItem = parent;
          this._expandedItem = parent;
          this._items = [...this._items];
          if(nodeWithMaxDepth.level === 2) {
            const dropDownList = this.dropDownLists.find(item => item.id === this._activeItem.id);
            if(dropDownList) dropDownList.selectItem(nodeWithMaxDepth);
          } else {

          }
          this._changeDetector.detectChanges();
        }
      } else {
        this._makeDefaultSelection();
      }
    } else {
      this._makeDefaultSelection();
    }
  }


  public isActiveItem(item: DxNavigationTreeNode): boolean {
    if(this._activeItem) {
      return  this._activeItem.id === item.id;
    }
    return  false;
  }

  public isExpandedItem(item: DxNavigationTreeNode): boolean {
    if(this._expandedItem) {
      return  this._expandedItem.id === item.id;
    }
    return  false;
  }

  private _makeDefaultSelection(): void {
    this._activeItem = null;
    this._expandedItem = null;
    this._items = [...this._items];
  }


  private _init(): void {
    this._menuTree = new DxNavigationTree(this.menuData);
    this._menuTree.grow('parentId');
    this._items = this._menuTree.collectNodesByLevel(1);
  }
}
